import FitnessCenterRounded from '@mui/icons-material/FitnessCenterRounded';
import GroupsRounded from '@mui/icons-material/GroupsRounded';
import type { ModuleDefinition } from '../types';

export const trainingModule: ModuleDefinition = {
  key: 'training',
  label: 'Treinos',
  description: 'Programas, fichas, execução e evolução.',
  icon: FitnessCenterRounded,
  nav: [
    {
      to: '/alunos',
      label: 'Alunos',
      icon: GroupsRounded,
      rule: { module: 'training', anyPermission: ['clients.read'] },
    },
    {
      to: '/treinos',
      label: 'Treinos',
      icon: FitnessCenterRounded,
      rule: { module: 'training', anyPermission: ['training.self', 'training.programs.manage'] },
    },
  ],
  routes: [
    {
      path: '/alunos',
      lazy: async () => ({ Component: (await import('@/clients/ClientsPage')).ClientsPage }),
    },
    {
      path: '/alunos/:clientId',
      lazy: async () => ({
        Component: (await import('@/clients/ClientDetailPage')).ClientDetailPage,
      }),
    },
    {
      path: '/treinos',
      lazy: async () => ({ Component: (await import('./pages/TrainingPage')).TrainingPage }),
    },
    {
      path: '/treinos/exercicios',
      lazy: async () => ({
        Component: (await import('./pages/ExerciseLibraryPage')).ExerciseLibraryPage,
      }),
    },
    {
      path: '/treinos/programas/novo',
      lazy: async () => ({
        Component: (await import('./pages/ProgramEditorPage')).ProgramEditorPage,
      }),
    },
    {
      path: '/treinos/programas/:programId',
      lazy: async () => ({
        Component: (await import('./pages/ProgramEditorPage')).ProgramEditorPage,
      }),
    },
    {
      path: '/treinos/sessao/:sessionId',
      lazy: async () => ({
        Component: (await import('./pages/WorkoutPlayerPage')).WorkoutPlayerPage,
      }),
    },
  ],
};
